import { AdminGetUserResponse } from 'aws-sdk/clients/cognitoidentityserviceprovider';
import { useEffect, useReducer } from 'react';
import { Auth as authConstants } from '../../constants';
import { createReducer, State } from './reducer';
import { useCognito } from './useCognito';

type Input = {
  username?: null | undefined | string;
};

const reducer = createReducer<AdminGetUserResponse>();

export function useCognitoUser({
  username,
}: Input): State<AdminGetUserResponse> {
  const cognito = useCognito();
  const [state, dispatch] = useReducer(reducer, {
    loading: true,
    error: null,
    response: null,
  } as State<AdminGetUserResponse>);

  useEffect(() => {
    let isMounted = true;
    const unmount = () => {
      isMounted = false;
    };
    if (!cognito.client || !username) {
      return unmount;
    }

    dispatch({ type: 'loading' });

    cognito.client
      .adminGetUser({
        UserPoolId: authConstants.userPoolId,
        Username: username,
      })
      .promise()
      .then(response => {
        if (!isMounted) {
          return;
        }

        dispatch({ type: 'response', response });
      })
      .catch(error => {
        if (!isMounted) {
          return;
        }

        dispatch({ type: 'error', error });
      });

    return unmount;
  }, [dispatch, cognito.client, username]);

  if (cognito.loading) {
    return {
      ...state,
      loading: true,
    };
  }

  if (cognito.error) {
    return {
      ...state,
      error: cognito.error,
    };
  }

  return state;
}
